<div class="flex items-start gap-4">
  <div class="flex-2/3">
    @if (loading()) {
      <div>
        <app-loading />
      </div>
    } @else {
      @for (item of visibleItems(); track $index) {
        <div class="flex w-full flex-col gap-6 border-b border-gray-50 pb-5 last:border-0 last:pb-0">
          <div class="flex w-full flex-2/3 flex-col gap-4">
            <app-invoice-block [invoiceData]="item" [itemIndex]="+$index + 1" [length]="visibleItems().length" />
          </div>
        </div>
      } @empty {
        <app-error-data [title]="isArabic() ? 'لا يوجد بيانات' : 'No Data'" />
      }
    }
  </div>

  <div class="flex-1/3">
    <app-order-summary-card
      [orderData]="orderData()"
      [invoiceNo]="orderData()?.invoiceNo"
      [totalQuantity]="orderData()?.totalQuantity"
      [totalPharmacyPrice]="+(orderData()?.totalBusinessPrice ?? 0)"
      [totalPeoplePrice]="totalPeoplePrice()"
      [placedOn]="
        isArabic()
          ? orderData()?.deliveryAddress?.region?.titleAr +
            ' ' +
            orderData()?.deliveryAddress?.city?.titleAr +
            ' ' +
            orderData()?.deliveryAddress?.governorate?.titleAr +
            ' '
          : orderData()?.deliveryAddress?.region?.titleEn +
            ' ' +
            orderData()?.deliveryAddress?.city?.titleEn +
            ' ' +
            orderData()?.deliveryAddress?.governorate?.titleEn
      "
      [deliveryMan]="orderData()?.distributor?.fullName"
      [total]="+(orderData()?.totalBusinessPrice ?? 0)"
      [expectedDeliveryDate]="orderData()?.expectedDeliveryDate" />
  </div>
</div>
